export function update(state, payload) {
    const lists = payload.map(list => ({...list, dirty: false}));
    return {...state, lists: lists, dirty: false};
}

export function error(state, payload) {
    return {...state, error: payload};
}

export function toggle_intention(state, payload) {
    const lists = state.lists.map((list) => {
        if (list.code === payload) {
            return {...list, intent: !list.intent};
        }
        return list;
    });
    const dirty = lists.some(list => list.intent);
    return {...state, lists, dirty: dirty};
}



// WEBPACK FOOTER //
// ./app/reducers/mail-lists.js